export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_of.js
// module id = 2545
// module chunks = 1